import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { SolutionAddSchema } from "../../../ValidationSchema";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


const SolutionAdd = () => {
  const Navigate = useNavigate();
  const [initialValues] = useState({
    title: "",
    description: "",
    image_path: null,
    date_time: "",
  });

  const AddSolution = useFormik({
    initialValues,
    validationSchema: SolutionAddSchema,

    onSubmit: (values, action) => {
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append("image_path", values.image_path);
      formData.append("date_time", values.date_time);
      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/solution/store`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate("/admin/solution", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    // UserRole();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Add Solution</h1>
          <p className="al-sub">Create a new solution.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddSolution.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18h6" /><path d="M10 22h4" /><path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.3h6c0-1 .4-1.8 1-2.3A7 7 0 0 0 12 2z" /></svg></div>
            <h3 className="al-cardhead__title">Solution Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Title</label>
              <input className="al-input" type="text" placeholder="Enter Title"
                value={AddSolution.values.title} onChange={AddSolution.handleChange} onBlur={AddSolution.handleBlur} name="title" />
              {AddSolution.errors.title && AddSolution.touched.title ? (
                <div className="al-err">{AddSolution.errors.title}</div>
              ) : null}
            </div>

            <div className="al-form__full">
              <label className="al-label">Description</label>
              <CKEditor
                editor={ClassicEditor}
                data={AddSolution.values.description}
                className="custom-ckeditor"
                onChange={(event, editor) => {
                  const data = editor.getData();
                  AddSolution.setFieldValue("description", data);
                }}
                onBlur={() => AddSolution.setFieldTouched("description", true)}
              />
              {AddSolution.errors.description && AddSolution.touched.description && (
                <div className="al-err">{AddSolution.errors.description}</div>
              )}
            </div>

            <div>
              <label className="al-label">Image</label>
              <input className="al-input al-input--file" type="file" name="image_path" accept="image/*"
                onChange={(e) => AddSolution.setFieldValue("image_path", e.target.files && e.target.files[0])}
                onBlur={AddSolution.handleBlur} />
              {AddSolution.errors.image_path && AddSolution.touched.image_path ? (
                <div className="al-err">{AddSolution.errors.image_path}</div>
              ) : null}
            </div>

            <div>
              <label className="al-label">Date Time</label>
              <input className="al-input" type="date" placeholder="Enter Date Time"
                value={AddSolution.values.title} onChange={AddSolution.handleChange} onBlur={AddSolution.handleBlur} name="date_time" />
              {AddSolution.errors.date_time && AddSolution.touched.date_time ? (
                <div className="al-err">{AddSolution.errors.date_time}</div>
              ) : null}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Create Solution
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SolutionAdd;
